<template>
  <div class="form-group" :class="classes" :key="id">
    <label :for="id" v-if="label">
      {{ label }}
    </label>
    <Field
      :as="typeAs"
      :name="name"
      :placeholder="placeholder"
      :disabled="disabled"
      :id="id"
      :rules="rules"
      :maxlength="maxlength"
      :rows="rows"
      v-model="val"
      @input="updatedValue"
    />
    <ErrorMessage :name="name" class="error-message" />
  </div>
</template>
<script>
import { Field, ErrorMessage } from "vee-validate";
import { ref } from "vue";

export default {
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    label: {
      type: String,
      default: () => null,
    },
    rules: {
      type: String,
      default: () => "",
    },
    value: {
      type: String,
    },
    name: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    classes: {
      type: String,
      default: () => "col-6",
    },
    type: {
      type: String,
      default: () => "text",
    },
    id: {
      type: String,
      default: () => "",
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    maxlength: {
      type: String,
      default: () => "",
    },
    rows: {
      type: String,
      default: () => "",
    },
  },
  computed: {
    typeAs() {
      return this.type === "textarea" ? "textarea" : "input";
    },
  },
  methods: {
    updatedValue(event) {
      this.$emit("updated-value", {
        name: this.name,
        value: event.target.value,
      });
    },
  },
  mounted() {
    // fix changing v-model
    // problem with keeping old value
    this.$nextTick(() => {
      this.val = this.value || "";
    });
  },
  setup() {
    const val = ref("");

    return {
      val,
    };
  },
};
</script>
